/* custom.js — shared page behavior for the Custom Jewelry Experience family.
   Reveal-once choreography (html.fx gate), FAQ accordion, smooth anchor scroll.
   Safe from file:// — no fetch, no modules. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal system: hidden states only exist under html.fx */
  if (!REDUCED && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('fx');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-rv],[data-rv-kids]'),
      function (el) { io.observe(el); }
    );
  }

  /* FAQ accordion */
  Array.prototype.forEach.call(document.querySelectorAll('.cust26-faq-q'), function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.cust26-faq-item');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Smooth in-page anchors (CTAs that scroll to the form / sections) */
  Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), function (a) {
    a.addEventListener('click', function (ev) {
      var id = a.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (!target) return;
      ev.preventDefault();
      target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });
})();
